export const STRONG_PASSWORD_RULES = [
  {
    label: "12+ characters",
    test: (value) => value.length >= 12,
  },
  {
    label: "Upper & lower case",
    test: (value) => /[a-z]/.test(value) && /[A-Z]/.test(value),
  },
  {
    label: "At least one number",
    test: (value) => /\d/.test(value),
  },
  {
    label: "At least one symbol",
    test: (value) => /[^A-Za-z0-9]/.test(value),
  },
];

export const meetsStrongPasswordPolicy = (value) =>
  STRONG_PASSWORD_RULES.every((rule) => rule.test(value));
